import { useState, Fragment, useEffect } from 'react'

import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap'
import Utils from '../Utils'


const ModalEditarUsuario = ({ isOpen, closeModal, user, fetchUsuarios }) => {

    const _user = (user == null) ? { Nombre: "", idUsuario: 0, Celular: "", Email: "" } : user


    const [form, setForm] = useState(_user)

    const onSubmit = event => {
        event.preventDefault()
    }

    const handleInputChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    const guardarCambios = async () => {
        if(window.confirm("Realmente quieres modificar el lote?") == false) {
            return;
        }
        //
        try {
            await Utils.API.ModificarUsuario(user.idUsuario, form.Celular, form.Email)
            //refresh
            fetchUsuarios()
            closeModal()
            alert("Lote modificado!")
        } catch(err) {
            Utils.AlertError(err, "No se pudo actualizar el Lote")
        }
    }

    useEffect(() => {
        setForm(_user)
    }, [user])

    if(user == null) {
        return ;
    }

    return(
        <Modal
            isOpen={isOpen}
            backdrop={"static"}
        >
            <ModalHeader>Modificar Usuario</ModalHeader>
            <ModalBody>
                <h6>Modificando: {_user.Nombre}</h6>
                <Form>
                    <FormGroup>
                        <Label>Celular:</Label>
                        <Input
                            onChange={handleInputChange}
                            name="Celular"
                            value={form.Celular}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label>Email:</Label>
                        <Input
                            onChange={handleInputChange}
                            type="email"
                            name="Email"
                            value={form.Email}
                        />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button onClick={guardarCambios} color='primary'>
                    Modificar
                </Button>
                <Button onClick={closeModal} color='danger'>
                    Cancelar
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ModalEditarUsuario